/**
 * The only import path to BlockNote and Mantine: both load in the lazy Doc
 * chunk, never in the main bundle.
 */
import { lazy } from "react";

const loadDocEditor = () => import("./doc-editor");

export const LazyDocEditor = lazy(loadDocEditor);

/**
 * Warms the Doc chunk so an opened Doc renders without its loading excerpt.
 * A failed fetch is harmless: the editor retries on use.
 */
export function preloadDocEditor(): void {
  loadDocEditor().catch(() => {});
}

export const LazyDocReadOnlyView = lazy(() => import("./doc-read-only-view"));

/** Highlights-frame entries in a Doc (selection-toolbar-helpers). */
export const loadDocHighlights = () => import("./doc-highlights");
